module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("The Believing Scientist")]), _vm._v(" "), _c('link', {
    attrs: {
      "href": "../styles/stylesheet.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "OT"
  }, [_vm._v("CONTENTS")]), _vm._v(" "), _c('p', {
    staticClass: "Toc1a"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/part001#pt-001",
      "id": "pt001"
    }
  }, [_c('b', [_vm._v("SCIENCE VERSUS RELIGION?")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter001#ch-001",
      "id": "ch001"
    }
  }, [_vm._v("01 Retelling the Story of Science")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1b"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part002#pt-002",
      "id": "pt002",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("EVOLUTION")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter002#ch-002",
      "id": "ch002",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("02 Evolution without Tears")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter003#ch-003",
      "id": "ch003",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("03 The Devil’s Chaplain Confounded")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter004#ch-004",
      "id": "ch004",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("04 Mismeasure of Man")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter005#ch-005",
      "id": "ch005",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("05 The Design of Evolution")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter006#ch-006",
      "id": "ch006",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("06 Chance, by Design")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter007#ch-007",
      "id": "ch007",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("07 Debating Darwin")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter008#ch-008",
      "id": "ch008",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("08 The End of Intelligent Design?")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1b"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part003#pt-003",
      "id": "pt003",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("MIND AND SOUL")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter009#ch-009",
      "id": "ch009",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("09 More Than Machines: Physics and Free Will")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter010#ch-010",
      "id": "ch010",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10 Does Quantum Mechanics Make It Easier to Believe in God?")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter011#ch-011",
      "id": "ch011",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11 Faith and Quantum Theory")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter012#ch-012",
      "id": "ch012",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12 A Mystery Wrapped in an Enigma")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter013#ch-013",
      "id": "ch013",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13 Thomas Nagel on the Human Mind")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter014#ch-014",
      "id": "ch014",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14 Matter over Mind")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter015#ch-015",
      "id": "ch015",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15 Theories of Everything")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1b"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part004#pt-004",
      "id": "pt004",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("THE BIG BANG AND CREATION")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter016#ch-016",
      "id": "ch016",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16 Modern Physics, the Beginning, and Creation")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter017#ch-017",
      "id": "ch017",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17 Physics, the Nature of Time, and Theology")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter018#ch-018",
      "id": "ch018",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18 Much Ado about “Nothing”: Stephen Hawking and the Self-Creating Universe")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1b"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part005#pt-005",
      "id": "pt005",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("REDUCTIONISM ")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter019#ch-019",
      "id": "ch019",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19 Fearful Symmetries")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter020#ch-020",
      "id": "ch020",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20 The Human Genome in Human Context")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1b"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part006#pt-006",
      "id": "pt006",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("SCIENCE AS A SUBSTITUTE FOR RELIGION")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter021#ch-021",
      "id": "ch021",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21 The Idol of Science")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter022#ch-022",
      "id": "ch022",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22 Prophet of Pointlessness")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1b"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part007#pt-007",
      "id": "pt007",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("FINDING GOD THROUGH SCIENCE")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter023#ch-023",
      "id": "ch023",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23 The (Scientific) Case for God")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter024#ch-024",
      "id": "ch024",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24 The Form of Speaking")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1b"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part008#pt-008",
      "id": "pt008",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("MISCHIEVOUS MYTHS ABOUT SCIENTIFIC REVOLUTIONARIES ")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter025#ch-025",
      "id": "ch025",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25 From Myth to History and Back")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter026#ch-026",
      "id": "ch026",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26 Crackpots and the Einstein Myth")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1b"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/endnotes#end-001",
      "id": "end001",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Notes and Sources")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1ba"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/backmatter001#bm-001",
      "id": "bm001",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Direct Quotations")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-218d4410","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 63
// module chunks = 0